/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { useCurrentDynamicField } from "cms/fields/dynamic-field";
import { isArrayNotEmpty } from "utils/empty-exists";

const RichTextFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};

    return (
        <FieldDisplayWrapper>
            {isArrayNotEmpty(values)&&
                values.map((item, index) => {
                    const { value } = item || {};
                    return (
                        <RichTextPreview key={index} richtext={value} />
                    );
                })
            }
        </FieldDisplayWrapper>
    );
};
RichTextFieldDisplay.displayName = "RichTextFieldDisplay";
export { RichTextFieldDisplay };
